"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RealityCheckEpic = void 0;
var _reduxObservable = require("redux-observable");
var _operators = require("rxjs/operators");
var _types = require("../com/types");
var _types2 = require("./types");
var _rxjs = require("rxjs");
var _types3 = require("../ui/types");
var _RoundState = require("../enums/RoundState");
var _types4 = require("../game/types");
var _DialogState = require("../../../ui/enums/DialogState");
var _CommandType = require("../../dovahzul/CommandType");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var RealityCheckEpic = exports.RealityCheckEpic = /*#__PURE__*/_createClass(function RealityCheckEpic() {
  var _this = this;
  _classCallCheck(this, RealityCheckEpic);
  _defineProperty(this, "getEpic", function () {
    return (0, _reduxObservable.combineEpics)(_this.commandSpinResponse, _this.commandRoundEndResponse, _this.rcOn);
  });
  _defineProperty(this, "commandSpinResponse", function (action$) {
    return action$.pipe((0, _reduxObservable.ofType)(_types.COMMAND_PLAY), (0, _operators.filter)(function (a) {
      return _CommandType.CommandType.SpinResponse === a.payload.type;
    }), (0, _operators.mergeMap)(function (a) {
      return (0, _rxjs.of)({
        type: _types2.RC_LOSS,
        payload: a.payload.payLines * a.payload.coins * a.payload.denomination * 100
      });
    }));
  });
  _defineProperty(this, "commandRoundEndResponse", function (action$, store) {
    return action$.pipe((0, _reduxObservable.ofType)(_types.COMMAND_PLAY), (0, _operators.filter)(function (a) {
      return _CommandType.CommandType.RoundEndResponse === a.payload.type && a.payload.totalCoinsWon > 0;
    }), (0, _operators.mergeMap)(function (a) {
      return (0, _rxjs.of)({
        type: _types2.RC_WIN,
        // as cents
        payload: a.payload.totalCoinsWon * store.value.bet.denomination * 100
      });
    }));
  });
  /**
   * Starts Responsible Gaming Reminders. Defaults to showing every 60 minutes.
   */
  _defineProperty(this, "rcOn", function (action$, store) {
    return action$.pipe((0, _reduxObservable.ofType)(_types2.RC_ON), (0, _operators.switchMap)(function (a) {
      return (0, _rxjs.timer)(a.payload.next * 1000, a.payload.interval * 1000).pipe((0, _operators.takeUntil)(action$.pipe((0, _reduxObservable.ofType)(_types2.RC_ON))), (0, _operators.mergeMap)(function () {
        if (store.value.game.roundState == _RoundState.RoundState.Ended) {
          return (0, _rxjs.of)({
            type: _types3.REQUEST_DIALOG_STATE,
            payload: _DialogState.DialogState.RG_REMINDER
          });
        }
        // if round is playing we instead wait for round end.
        return action$.pipe((0, _reduxObservable.ofType)(_types4.ROUND_END), (0, _operators.take)(1), (0, _operators.mapTo)({
          type: _types3.REQUEST_DIALOG_STATE,
          payload: _DialogState.DialogState.RG_REMINDER
        }));
      }));
    }));
  });
});
//# sourceMappingURL=epics.js.map